import Input from "shared/ui/input";
import { concatClassnames } from "shared/utils/concatClassnames";

export enum StandardProductAmountType {
  BACKGROUND,
  TRANSPARENT,
}

interface Props {
  type: StandardProductAmountType;
  className?: string;
  inputClassName?: string;
  amount: number;
  setAmount: (amount: number) => void;
  readOnly?: boolean;
}

const StandardProductAmount = ({
  type,
  inputClassName,
  className,
  amount,
  setAmount,
  readOnly = false,
}: Props) => {
  return (
    <div className={concatClassnames(className)}>
      <Input
        type="number"
        className={concatClassnames(
          "show-number-input-arrows gg-w-16  gg-px-3 gg-py-2",
          type === StandardProductAmountType.TRANSPARENT
            ? "gg-bg-transparent gg-border gg-border-white-400 gg-text-white"
            : "",
          inputClassName
        )}
        min={1}
        value={amount ? amount.toString() : ""}
        onChange={(e) => {
          const parsed = parseInt(
            e.currentTarget.value.replace(/[^0-9]/g, "")
          );
          setAmount(isNaN(parsed) ? 0 : parsed);
        }}
        onBlur={(e) => {
          const parsedValue = parseInt(
            e.currentTarget.value.replace(/[^0-9]/g, "")
          );
          setAmount(parsedValue > 1 ? parsedValue : 1);
        }}
        readOnly={readOnly}
      />
    </div>
  );
};
export default StandardProductAmount;
